<template>
    <div>
        <kt-panel>
            <div class="accordion accordion-toggle-arrow" id="pspSettlementFilter">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="pspSettlementFilterHeading">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#pspSettlementFilterForm"
                             aria-controls="pspSettlementFilterForm">
                            {{ $t('label.search') }}
                        </div>
                    </div>
                    <div id="pspSettlementFilterForm" class="collapse" aria-labelledby="pspSettlementFilterHeading"
                         data-parent="#pspSettlementFilter">
                        <div class="card-body">
                            <form id="psp_settlement_filter_form" @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_full_name">
                                                    {{ $t('label.user') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="full_name"
                                                        dir="rtl"
                                                        name="full_name"
                                                        id="psp_settlement_full_name"
                                                        v-model="query.full_name"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_terminal_number">
                                                    {{ $t('label.terminal_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="terminal_number"
                                                        dir="ltr"
                                                        name="terminal_number"
                                                        id="psp_settlement_terminal_number"
                                                        v-model="query.terminal_number"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_account_number">
                                                    {{ $t('label.sheba_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="account_number"
                                                        dir="ltr"
                                                        name="account_number"
                                                        id="psp_settlement_account_number"
                                                        v-model="query.account_number"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_pan">
                                                    {{ $t('label.card_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        ref="pan"
                                                        dir="ltr"
                                                        name="pan"
                                                        id="psp_settlement_pan"
                                                        v-model="query.pan"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_psp">
                                                    {{ $t('label.psp') }}
                                                </kt-form-label>
                                                <kt-form-select
                                                        class="form-control"
                                                        v-model="query.psp"
                                                        name="psp"
                                                        id="psp_settlement_psp"
                                                >
                                                    <option
                                                            :key="psp.value"
                                                            v-for="psp in pspLoopList"
                                                            :value="psp.value"
                                                    >
                                                        {{ psp.title }}
                                                    </option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="psp_settlement_reset_from_date"
                                                        @click="query.from_date = null"
                                                        type="button"
                                                        class="btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD"
                                                        display-format="dddd jDD jMMMM jYYYY"
                                                        input-class="form-control"
                                                        id="psp_settlement_from_date"
                                                        name="from_date"
                                                        v-model="query.from_date"
                                                        type="date"/>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="4" md="4" lg="3">
                                            <kt-form-group>
                                                <kt-form-label for="psp_settlement_to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="psp_settlement_reset_to_date"
                                                        @click="query.to_date = null"
                                                        type="button"
                                                        class="btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD"
                                                        display-format="dddd jDD jMMMM jYYYY"
                                                        input-class="form-control"
                                                        id="psp_settlement_to_date"
                                                        name="to_date"
                                                        v-model="query.to_date"
                                                        type="date"/>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" lg="6">
                                            <input type="submit" class="btn btn-success btn-wide"
                                                   :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </kt-panel>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "./datatable/psp-settlements-columns";
    import {pspLoopList} from "@/constants/psp";

    export default {
        name: 'PspSettlements',
        data() {
            return {
                query: {},
                pspLoopList,
            };
        },
        computed: {
            datatableProps() {
                return {
                    id: "psp_settlements_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('settlement/admin/psp-settlements'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => res.data.data,
                                params: this.query,
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        saveState: {cookie: false},
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                }
            },
        },
        methods: {
            filterAction() {
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
        },
    }
</script>
